import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 w-full">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                {aboutInfo.title}
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>{aboutInfo.desc1}</p>
                <p>{aboutInfo.desc2}</p>
                <p>{aboutInfo.desc3}</p>
              </div>
            </div>

            <div className="flex-1 w-full max-w-[400px]">
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">12,800+</div>
                  <div className="text-xs text-foreground-500">收录作品</div>
                </div>
                <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-1">500万+</div>
                  <div className="text-xs text-foreground-500">累计读者</div>
                </div>
                <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-500 mb-1">80万+</div>
                  <div className="text-xs text-foreground-500">日活跃用户</div>
                </div>
                <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">200+话</div>
                  <div className="text-xs text-foreground-500">每日更新</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}